import { render } from "./mega-nav.vue?vue&type=template&id=573e6e73"
import script from "./mega-nav.vue?vue&type=script&lang=js"
export * from "./mega-nav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kevinschade/Code/bioeffect/New BIOEFFECt Wesbstie themes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__